export const alertReducerKey = "alert";
export const alertInitialState = {
  open: false,
  message: "",
  severity: "error",
};
